import { useParams } from '@tanstack/react-router';
import type { JSX } from 'react';
import { useMemo } from 'react';

import { RatingPage, createRatingApi } from '@/features/sessions';

import { clientFetcher } from './bp03';
import { useClientDeps } from './deps';

/**
 * BP-05 §6's one client-app row: `/r/{token}`, the rating page (R13).
 *
 * Not gated, and not gateable: the token **is** the credential. It arrives in a WhatsApp
 * message, names exactly one session, and the api decides on its own whether it is still
 * good — so there is nothing for the browser to check and nothing for a client to sign
 * into. The page posts and says thank you; it never reads the session back, because a
 * client who may rate a visit still has no business seeing what was recorded during it.
 */

/** The `{token}` of `/r/{token}`, or `''` off that route. */
export function ratingTokenOf(params: { token?: string }): string {
  return params.token ?? '';
}

export function RatingRoute(): JSX.Element {
  const deps = useClientDeps();
  const params: { token?: string } = useParams({ strict: false });
  const api = useMemo(() => createRatingApi(clientFetcher(deps.fetcher)), [deps.fetcher]);
  return <RatingPage token={ratingTokenOf(params)} rate={api.rate} />;
}
